import { Switch, useScreenWidth } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import EditNoteIcon from "@mui/icons-material/EditNote";

export type EditMode = "normal" | "bulk";

interface Props {
  editMode: EditMode;
  onEditModeChange(mode: EditMode): void;
}

export const SwitchEditModeButton = ({ editMode, onEditModeChange }: Props) => {
  const { isMaxPhone } = useScreenWidth();
  const { t } = useTranslate(["Global"]);
  return (
    <Switch
      checked={editMode === "bulk"}
      onChange={(e, checked) => {
        onEditModeChange(checked ? "bulk" : "normal");
      }}
      label={!isMaxPhone ? t("Bulk edit", { ns: "Global" }) : <EditNoteIcon />}
      formControlLabelProps={{ sx: { px: !isMaxPhone ? 2 : 1 } }}
    />
  );
};
